import { httpsCallable } from 'firebase/functions';
import { functions } from '../Firebase';
export function generateCallableFunction(name, validator) {
    const firebaseFunction = httpsCallable(functions, name);
    return async (request) => {
        const response = (await firebaseFunction(request)).data;
        if (!validator.is(response)) {
            throw new Error('Response data was not valid');
        }
        return response;
    };
}
export function generateCurrentAppLocation(document) {
    const colon_port = document.location.port ? `:${document.location.port}` : '';
    return `${document.location.protocol}//${document.location.hostname}${colon_port}`;
}
function hashString(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
export function hslFromString(str) {
    const hash = hashString(str);
    const h = hash % 360;
    return `hsl(${h}, 100%, 35%)`;
}
